module.exports = __webpack_public_path__ + "static/media/mainChart1ForError2.b6f3c5e4.png";